import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import ClariTheme from 'Utils/theme/ClariTheme';

const styles = {
  root: {},
};

const FireEmptyIcon = ({ classes }) => {
  return (
    <svg
      className={classes.root}
      width="17"
      height="21"
      viewBox="0 0 17 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" fill="none" fillRule="evenodd">
        <g
          id="Hotlist----Call-step-page"
          transform="translate(-111 -226)"
          stroke={ClariTheme.palette.text.accentGray}
        >
          <path
            d="M120.554721,244.23652 C120.888544,243.557763 121.263209,242.873347 121.403528,242.122372 C121.775106,240.133626 120.822397,237.884919 119.243189,236.670088 C119.30944,238.052499 119.265307,239.492622 118.953498,240.844274 C118.586446,242.435724 116.839144,245.197254 114.881259,244.879067 C113.0424,244.58022 112.131457,241.816941 112.015724,240.281454 C111.887853,238.58528 112.539143,236.637374 113.996652,235.641355 C113.812817,236.881081 113.669412,238.689285 115.151816,239.114049 C116.86013,239.603725 117.049211,238.206706 116.877104,236.875835 C116.627225,234.943874 116.052986,233.262822 116.767852,231.359049 C117.46163,229.511342 118.866261,228.09344 120.477669,227 C119.83039,229.371229 119.080238,233.155834 121.392109,234.945623 C122.642945,235.914072 123.75089,235.566155 123.558826,234.036738 C123.433938,233.042056 123.089827,232.051387 122.740881,231.114931 C125.922648,233.435649 128.236783,236.938176 127.190561,241.081706 C126.473329,243.922345 123.62734,246.461875 120.580542,245.928683 C119.757556,245.82581 120.386008,244.5795 120.554721,244.23652 Z" // eslint-disable-line
            id="Fill-1-Copy-12"
          />
        </g>
      </g>
    </svg>
  );
};

FireEmptyIcon.displayName = 'FireEmptyIcon';
FireEmptyIcon.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default withStyles(styles)(FireEmptyIcon);
